import React, { useEffect, useState } from "react";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Strings from "../commons/string";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

import { Button, Col, Divider, Form, InputNumber, Row, Space } from "antd";

import styles from "../pages/RentInfo.module.css";
import RentImageViewer from "./RentImageViewer";

function RentCarDetail({
    rent,
    onChangeRentBattery,
}: {
    rent: Types.RentDto;
    onChangeRentBattery?: (rent: Types.RentDto, startSoc: number | null, endSoc: number | null) => void;
}) {
    const [rentCarImageMode, setRentCarImageMode] = useState<"START" | "END">("START");

    const [tempStartBatterySoc, setTempStartBatterySoc] = useState<number | null>(null);
    const [tempEndBatterySoc, setTempEndBatterySoc] = useState<number | null>(null);

    useEffect(() => {
        if (rent?.startBatterySoc) {
            setTempStartBatterySoc(rent?.startBatterySoc);
        }
        if (rent?.endBatterySoc) {
            setTempEndBatterySoc(rent?.endBatterySoc);
        }
    }, [rent]);

    return (
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
            <Space direction="vertical" size={10} style={{ width: "100%" }}>
                <Divider className={styles.subTitle} orientation="left">
                    <span>차량 상태</span>
                </Divider>
                <Form layout="inline" style={{ border: "solid 1px #DBDFE5" }}>
                    <Row style={{ width: "100%" }}>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" name="startBatterySoc" label="출차 배터리">
                                <Space size={5}>
                                    <InputNumber
                                        placeholder="출차 배터리량"
                                        value={tempStartBatterySoc}
                                        onChange={(value) => setTempStartBatterySoc(value)}
                                    ></InputNumber>
                                    <span>%</span>
                                    <Button onClick={() => onChangeRentBattery && onChangeRentBattery(rent, tempStartBatterySoc, tempEndBatterySoc)}>
                                        수정
                                    </Button>
                                </Space>
                                {/* <span>{rent?.startBatterySoc ? rent.startBatterySoc + "%" : Strings.dash}</span> */}
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm searchLastRow" name="endBatterySoc" label="도착 배터리">
                                <Space size={5}>
                                    <InputNumber
                                        placeholder="반납 배터리량"
                                        value={tempEndBatterySoc}
                                        onChange={(value) => setTempEndBatterySoc(value)}
                                    ></InputNumber>
                                    <span>%</span>
                                    <Button onClick={() => onChangeRentBattery && onChangeRentBattery(rent, tempStartBatterySoc, tempEndBatterySoc)}>
                                        수정
                                    </Button>
                                </Space>
                                {/* <span>{rent?.endBatterySoc ? rent.endBatterySoc + "%" : Strings.dash}</span> */}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

                {/*<Row gutter={10}>
                    <Col xs={12} className="gutter-row">
                        <Button style={{ width: "100%" }} onClick={() => setRentCarImageMode("START")}>
                            출차전
                        </Button>
                    </Col>
                    <Col xs={12} className="gutter-row">
                        <Button style={{ width: "100%" }} onClick={() => setRentCarImageMode("END")}>
                            반납후
                        </Button>
                    </Col>
                </Row>*/}
            </Space>
            {/*<Space direction="vertical" size={10} style={{ width: "100%" }}>
                <Col span={24}>
                    <h4 style={{ margin: 0 }}>관리자</h4>
                </Col>
                {rent && <RentImageViewer rent={rent} uploader="MANAGER" uploadTiming={rentCarImageMode} />}
                <Col span={24}>
                    <h4 style={{ marginBottom: 0 }}>예약자</h4>
                </Col>
                {rent && <RentImageViewer rent={rent} uploader="USER" uploadTiming={rentCarImageMode} />}
            </Space>*/}
        </Space>
    );
}

export default RentCarDetail;
